import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-right-circle-semifilled-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "currentColor" },
        React.createElement("circle", { cx: 8.5, cy: 8.5, r: 7.5, fillRule: "evenodd", opacity: 0.15 }),
        React.createElement("path", { d: "m9.354 5.646 2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L10.292 9H5.5a.5.5 0 0 1 0-1h4.792L8.646 6.354a.5.5 0 0 1-.057-.638l.057-.07a.5.5 0 0 1 .708 0Z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
